import React from "react";

interface CheckIconProps {
  size?: number;
}

const CheckIcon: React.FC<CheckIconProps> = ({ size = 16 }) => {
  return (
    <div style={{ width: `${size}px`, height: `${size}px` }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <g clipPath="url(#clip0_5295_4195)">
          <mask
            id="mask0_5295_4195"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="17"
            height="17"
          >
            <path
              d="M8.16667 14.9002C9.04232 14.9014 9.90955 14.7294 10.7185 14.3943C11.5275 14.0592 12.2623 13.5676 12.8807 12.9476C13.5007 12.3292 13.9923 11.5944 14.3274 10.7854C14.6625 9.97645 14.8345 9.10921 14.8333 8.23357C14.8345 7.35792 14.6625 6.49069 14.3274 5.68171C13.9923 4.87272 13.5006 4.13794 12.8807 3.51957C12.2623 2.89958 11.5275 2.4079 10.7185 2.0728C9.90955 1.73769 9.04232 1.56577 8.16667 1.5669C7.29103 1.56578 6.4238 1.73772 5.61481 2.07282C4.80583 2.40792 4.07104 2.89959 3.45267 3.51957C2.8327 4.13794 2.34103 4.87272 2.00593 5.68171C1.67082 6.49069 1.49889 7.35792 1.50001 8.23357C1.49887 9.10921 1.6708 9.97645 2.0059 10.7854C2.341 11.5944 2.83268 12.3292 3.45267 12.9476C4.07104 13.5675 4.80583 14.0592 5.61481 14.3943C6.4238 14.7294 7.29103 14.9013 8.16667 14.9002Z"
              fill="white"
              stroke="white"
              strokeWidth="2.66667"
              strokeLinejoin="round"
            />
            <path
              d="M5.5 8.2334L7.5 10.2334L11.5 6.2334"
              stroke="black"
              strokeWidth="2.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_5295_4195)">
            <path
              d="M0.166504 0.233398H16.1665V16.2334H0.166504V0.233398Z"
              fill="#00B7F4"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5295_4195">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.233887)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default CheckIcon;
